export default "__VITE_ASSET__1c66c9b0__"